module.exports = __webpack_public_path__ + "img/instagram.19ab0166.svg";